import axios from 'axios';
import { setupErrorInterceptorTo } from './errorInterceptor';
import { setupRequestInterceptorTo } from './requestInterceptor';

const axiosInstance = axios.create();

setupRequestInterceptorTo(axiosInstance);
setupErrorInterceptorTo(axiosInstance);
export default axiosInstance;
